<div [class]="noticeClasses" [attr.id]="id || null">
  <div class="notice__content">
    @if (!hideIcon) {
      @if (iconImage) {
        <img [src]="iconImage" [alt]="iconImageAlt" class="icon">
      } @else if (iconHref) {
        <svg class="icon">
          <use [attr.xlink:href]="iconHref"></use>
        </svg>
      }
    }
    <div class="notice__content-copy">
      @if (title) {
        <p><strong>{{ title }}</strong></p>
      }
      @if (message) {
        <p [innerHTML]="message"></p>
      }
    </div>
  </div>

  @if (hasTrayContent) {
    <div class="notice__tray">
      <ng-content select="[highlightMessageTray]"></ng-content>
    </div>
  }
</div>
